/* eslint-disable react/prop-types */

import { useSelector } from 'react-redux';
import styled from 'styled-components';
import imageHelper from '@utils/imageHelper';
import BackGroundImage from './BackgroundImage';

const Container = styled.div`
  margin-top: 144px;
  grid-column: span 24;
  position: relative;
  @media (max-width: 70.95em) {
    margin-top: 98px;
  }
`;

const Mission = styled.h1`
  font-weight: bold;
  font-size: 16px;
  line-height: 150%;
  letter-spacing: 2px;
  color: #08bd80;
  padding-top: 64px;
  margin: 0;
  @media (max-width: 70.95em) {
    display: block;
    font-size: 12px;
    text-align: center;
  }
  @media (max-width: 70.95em) {
    padding-top: 34px;
  }
`;

const Description = styled.h2`
  font-weight: bold;
  font-size: 40px;
  line-height: 120%;
  color: #3c4852;
  margin-top: 16px;
  @media (max-width: 70.95em) {
    font-size: 24px;
    text-align: center;
  }
`;

const LeadContainer = styled.div`
  margin-top: 56px;
  position: relative;
  @media (max-width: 70.95em) {
    margin-top: 32px;
  }
`;

const Leaders = styled.img`
  height: auto;
  width: 100%;
  object-fit: cover;
`;

const Info = styled.div`
  background: rgba(0, 0, 0, 0.6);
  backdrop-filter: blur(80px);
  border-radius: 8px;
  position: absolute;
  padding: 16px 24px;
  visibility: hidden;
  opacity: 0;
  transition: visibility 0s linear 0s, opacity 700ms;
  @media (max-width: 70.95em) {
    visibility: visible;
    opacity: 1;
    padding: 8px;
  }
`;

const Face = styled.div`
  position: absolute;
  width: 150px;
  height: 150px;
  z-index: 100;
  @media (max-width: 70.95em) {
    display: none;
  }
`;

const RFace = styled(Face)`
  left: 275px;
  top: 50px;
`;

const HFace = styled(Face)`
  left: 535px;
  bottom: 215px;
`;

const GFace = styled(Face)`
  right: 220px;
  top: 50px;
`;

const Roman = styled(Info)`
  top: 277px;
  left: 60px;
  ${RFace}:hover ~ & {
    visibility: visible;
    opacity: 1;
  }
  @media (max-width: 70.95em) {
    top: 37%;
    left: 5%;
  }
`;

const Hemesh = styled(Info)`
  bottom: 60px;
  left: 276px;
  ${HFace}:hover ~ & {
    visibility: visible;
    opacity: 1;
  }
  @media (max-width: 70.95em) {
    bottom: 10%;
    left: 21%;
  }
`;

const Gaurav = styled(Info)`
  top: 340px;
  right: 60px;
  ${GFace}:hover ~ & {
    visibility: visible;
    opacity: 1;
  }
  @media (max-width: 70.95em) {
    top: 47%;
    right: 7%;
  }
`;

const Name = styled.span`
  font-weight: bold;
  font-size: 24px;
  line-height: 120%;
  color: #ffffff;
  display: block;
  @media (max-width: 70.95em) {
    font-size: 8px;
  }
`;

const Position = styled.span`
  font-size: 16px;
  line-height: 150%;
  text-transform: uppercase;
  color: #ffffff;
  @media (max-width: 70.95em) {
    font-size: 6px;
  }
`;

const Faces = styled.div`
  @media (max-width: 70.95em) {
    display: none;
  }
`;

const LeaderName = ({ text, position }) => {
  return (
    <>
      <Name>{text}</Name>
      <Position>{position}</Position>
    </>
  );
};

const LeaderBlock = () => {
  const isMobile = useSelector(({ helper }) => helper.isMobile);
  const leadersImage = isMobile ? 'about/leaders-1.png' : 'about/leaders.png';
  return (
    <Container>
      <BackGroundImage />
      <Mission>FROM THE HEADQUARTERS</Mission>
      <Description>Our leaders</Description>
      <LeadContainer>
        <Leaders
          width="100%"
          height="auto"
          src={imageHelper.getImage(leadersImage)}
        />
        {!isMobile && (
          <Faces>
            <RFace />
            <HFace />
            <GFace />
            <Roman>
              <LeaderName text="Roman Saini" position="Co-Founder" />
            </Roman>
            <Hemesh>
              <LeaderName text="Hemesh Singh" position="Co-Founder and CTO" />
            </Hemesh>
            <Gaurav>
              <LeaderName text="Gaurav Munjal" position="Co-Founder and CEO" />
            </Gaurav>
          </Faces>
        )}
      </LeadContainer>
    </Container>
  );
};

export default LeaderBlock;
